<template>
    <div>
		<transition name="fade">
		    <Row v-if="mainTable.sarchCardShow"
		        :gutter="16">
		        <Col span="24">
		        <search-card :form="mainTable.searchForm"
		            :table-load-event="getMainTableRecords"
		            :table-search="mainTable.tableSearch" />
		        </Col>
		    </Row>
		</transition>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">产品系列管理</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['B', 'C'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreate">新增</Button>
						<Button type="primary"
							size="small"
							class="btns"
							shape="circle"
							icon="ios-search"
							@click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <Modal v-model="formShow"
            title="系列信息"
            @on-ok="onSave"
            @on-cancel="formShow = false">
            <Form ref="serialForm"
                :model="form"
                :rules="ruleValidate"
                label-position="top">
                <Row :gutter="16">
                    <Col span="12">
                    <FormItem label="系列名称"
                        prop="serialName">
                        <Input v-model="form.serialName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="品牌"
                        prop="brand">
                        <Input v-model="form.brand"></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="12">
                    <FormItem label="主图">
                        <SingleFileUploadWithName v-model="form.serialImageFile" />
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="排序 (数值越小越靠前)" prop="sort">
                        <Input v-model="form.sort" type="number"></Input>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
        </Modal>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { singleImageRender } from '@/libs/tableRowImageRender';

import { getSerialList, saveSerial, deleteSerialByUuid } from '@/api/modules/product-management/serial-management';

export default {
    name: 'SerialList',
    components: {
        SearchCard,
        SingleFileUploadWithName,
        StandPaginationTable
    },
    data() {
        return {
            mainTable: {
                tableColumns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '名称', key: 'serialName', align: 'center' },
                    { title: '品牌', key: 'brand', align: 'center' },
                    { title: '缩略图', align: 'center', render: (h, params) => singleImageRender(h, params.row.serialImageFile) },
                    { title: '排序', align: 'center', key: 'sort' },
                    { title: '所属苗场', key: 'seedFarmName', align: 'center' },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        visibility: this.$checkAccessArray(['B', 'C']) ? 'visible' : 'hidden'
                                    },
                                    on: {
                                        click: () => {
                                            this.onUpdate(params.row);
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style:{
                                        display: (this.$checkAccessArray(['B', 'C']))? 'inline-block' : 'none'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteSerial(params.row);
                                        }
                                    }
                                }, '删除')
                            ]);
                        }
                    }
                ],
                tableData: [],
                sarchCardShow: false,
                searchForm: [
				    { label: '名称', type: 'Input', value: '', name: 'serialName', sql: 'like' }
                ],
                tableLoading: false,
                tableSearch: search.getSearchParams()
            },
            form: {
                formEditMode: '',
                serialUuid: '',
                serialName: '',
                serialImageFile: '',
                brand: '',
                sort: 0
            },
            formShow: false,
            ruleValidate: {
                serialName: [{ required: true, message: ' ', trigger: 'blur' }]
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        this.mainTable.tableData = [];
        this.$destroy();
        next();
    },
    computed: {
        personName() {
            return this.$store.state.user.personName;
        },
        personType() {
            return this.$store.state.user.personType;
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getSerialList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        },
        onCreate() {
            this.form.formEditMode = FORM_EDIT_MODE_CREATE;
            this.form.serialUuid = '';
            this.form.serialName = '';
            this.form.serialImageFile = '';
            this.form.brand = '';
            this.form.sort = 0;

            this.formShow = true;
        },
        onUpdate(row) {
            this.form.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.form.serialUuid = row.serialUuid;
            this.form.serialName = row.serialName;
            this.form.serialImageFile = row.serialImageFile;
            this.form.brand = row.brand;
            this.form.sort = row.sort;

            this.formShow = true;
        },
        onSave() {
            this.$refs.serialForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }
                const data = Object.assign({}, this.form);
                saveSerial(data).then(res => {
                    if (res.code === 0) {
                        this.init();
                    }
                });
            });
        },
        // 删除系列
        deleteSerial(row){
            this.mainTable.tableLoading = true;
            deleteSerialByUuid({ serialUuid:row.serialUuid }).then(res => {
			    if (res.code === 0) {
                    this.$Message.success('删除成功！');
			        this.getMainTableRecords();
			    }
                else{
                    this.mainTable.tableLoading = false;
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
@titleHeight: 25px;

.border {
    border: 1px solid #c9c9c9;
    margin-bottom: 5px;
    padding: 5px 5px 5px 5px;
}

.title {
    height: @titleHeight;

    .text {
        font-weight: bold;
        float: left;
        line-height: @titleHeight;
    }

    .action {
        float: right;
    }
}
</style>
